import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Brief, CreateBriefRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateBrief() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateBriefRequest) => apiPost<Brief>('/v1/briefs', input),
    onSuccess: (brief) => {
      void qc.invalidateQueries({ queryKey: ['briefs'] });
      qc.setQueryData(['brief', brief.id], brief);
    },
  });
}
